var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 47.9985496C35 43.5810726 38.575811 40 43.0056329 40L76.9943671 40C81.415756 40 85 43.5735893 85 47.9985496L85 92.0014504C85 96.4189274 81.424189 100 76.9943671 100L43.0056329 100C38.584244 100 35 96.4264107 35 92.0014504L35 47.9985496zM45 35C45 32.2385763 47.2303666 30 50.0044356 30L69.9955644 30C72.7594379 30 75 32.2441952 75 35L75 40 45 40 45 35z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 50,
    y1: 20,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    x2: 70,
    y1: 20,
    y2: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 85C23.954305 85 15 93.954305 15 105M35 55C23.954305 55 15 46.045695 15 35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 35,
    y1: 70,
    y2: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 85C96.045695 85 105 93.954305 105 105M85 55C96.045695 55 105 46.045695 105 35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 85,
    y1: 70,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    x2: 60.5,
    y1: 40,
    y2: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.397d7e3468dcb6dea5044e0e9094066c.svg";
export { ForwardRef as ReactComponent };